import React from 'react'

import Stack from '@mui/material/Stack'

import { Beat } from '../../../types/CommonBeat'

import { CardError } from './CardError'
import { CardHeader, CardHeaderProps } from './CardHeader'
import { CardLoading } from './CardLoading'
import { ContentAndDescription, ContentAndDescriptionProps } from './ContentAndDescription'

interface BeatCardProps {
  altLoadingText?: string
  asteriskText?: string
  beat: Beat
  button?: React.ReactNode
  children?: React.ReactNode
  contentProps?: Omit<ContentAndDescriptionProps, 'beat'>
  errorText?: string
  feedback?: React.ReactNode
  header?: Omit<CardHeaderProps, 'title'>
  isError?: boolean
  isLoading?: boolean
  isMini?: boolean
}

// TODO: Update BeatCard layout to match the new spacing
// Remove this once the layout update is complete
// Note: For now, no changes have been made to the mini variant
// The mini layout should be updated once we touch the layout work

export const BeatCard = ({
  altLoadingText = '',
  asteriskText,
  beat,
  button = null,
  children,
  contentProps,
  errorText = '',
  feedback,
  header,
  isError = false,
  isLoading = false,
  isMini = false,
}: BeatCardProps) => {
  return (
    <Stack sx={{ height: '100%' }}>
      <CardHeader {...header} isMini={isMini} title={beat.html_title} />
      {isError ? (
        <CardError erroredText={errorText!} />
      ) : (
        <>
          <ContentAndDescription
            {...contentProps}
            asteriskText={asteriskText}
            beat={beat}
            isLoading={isLoading}
            isMini={isMini}
          >
            {isLoading ? <CardLoading altLoadingText={altLoadingText} /> : children}
          </ContentAndDescription>
          {!isMini && button}
          {/* TODO: For now, we're getting it as a ReactNode from Pulse. It will later be built here */}
          {feedback}
        </>
      )}
    </Stack>
  )
}
